
export const WIDGET_CMS_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-5 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            iconBox: "w-12 h-12 rounded-2xl flex items-center justify-center bg-violet-50",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-0.5"
        },
        actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-4 gap-3",
        card: "bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 hover:shadow-sm transition-shadow",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0",
        value: "text-xl font-bold text-gray-900",
        label: "text-xs text-gray-500"
    },
    filters: {
        grid: "grid grid-cols-1 md:grid-cols-3 gap-4",
        label: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 block",
        searchInput: "pl-9 bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200"
    },
    emptyState: {
        container: "flex flex-col items-center justify-center py-16 gap-3",
        iconBox: "w-16 h-16 rounded-2xl bg-violet-50 flex items-center justify-center",
        title: "text-sm font-semibold text-gray-700",
        subtitle: "text-xs text-gray-400",
        link: "text-sm text-[#7C3AED] font-medium hover:underline cursor-pointer"
    },
    // Página de detalhe do projeto (dedicada, dentro de Configurações — não é drawer).
    pageDetail: {
        container: "flex flex-col h-[calc(100vh-120px)] bg-white rounded-2xl border border-gray-100 overflow-hidden animate-in fade-in duration-300",
        backBar: "px-6 pt-4",
        backButton: "flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-[#7C3AED] transition-colors",
        header: {
            container: "flex items-center justify-between gap-4 px-6 py-4 border-b border-gray-100 bg-white"
        },
        body: "flex-1 flex flex-col min-h-0 overflow-hidden",
        footer: "border-t border-gray-100 bg-gray-50/80 px-6 py-3 flex items-center justify-between"
    },
    drawer: {
        overlay: "fixed inset-0 z-[9999] flex justify-end",
        backdrop: "absolute inset-0 bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200",
        container: "relative w-[90%] max-w-7xl h-full bg-white shadow-2xl flex flex-col animate-in slide-in-from-right duration-300",
        containerNarrow: "relative w-[90%] max-w-5xl h-full bg-white shadow-2xl flex flex-col animate-in slide-in-from-right duration-300",
        header: {
            container: "flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white",
            left: "flex items-center gap-3",
            iconBox: "w-10 h-10 rounded-xl flex items-center justify-center",
            title: "text-base font-bold text-gray-900",
            subtitle: "text-xs text-gray-500 mt-0.5",
            closeButton: "w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors"
        },
        errorBanner: "bg-red-50 border-b border-red-100 px-6 py-3 text-sm text-red-600 flex items-center gap-2",
        content: {
            container: "flex-1 flex overflow-hidden min-h-0",
            leftColumn: "w-[62%] p-6 overflow-y-auto max-h-full border-r border-gray-100 bg-white",
            rightColumn: "w-[38%] p-6 overflow-y-auto max-h-full bg-gradient-to-b from-slate-50 to-slate-100/50",
            full: "flex-1 p-6 overflow-y-auto max-h-full bg-white"
        },
        section: {
            container: "bg-white rounded-xl border border-gray-100 p-5 mb-5",
            titleWrapper: "flex items-center gap-3 mb-5",
            iconBox: "w-8 h-8 bg-[#F3E8FF] rounded-lg flex items-center justify-center text-[#7C3AED]",
            title: "text-base font-bold text-gray-900",
            label: "block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2",
            input: "text-sm border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200"
        },
        footer: {
            container: "border-t border-gray-100 bg-gray-50/80 px-6 py-3 flex items-center justify-between",
            left: "flex items-center gap-2",
            right: "flex items-center gap-3"
        }
    },
    listItem: {
        container: "flex items-center gap-3 px-4 py-3 border border-gray-100 rounded-xl hover:border-[#7C3AED]/40 hover:bg-violet-50/30 cursor-pointer transition-all group",
        title: "text-sm font-semibold text-gray-900",
        subtitle: "text-xs text-gray-500 line-clamp-1"
    },
    badge: {
        publicado: "text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border-green-200",
        rascunho: "text-xs font-medium flex items-center gap-1.5 bg-amber-50 text-amber-700 border-amber-200",
        dotVerde: "w-1.5 h-1.5 rounded-full bg-green-500",
        dotAmarelo: "w-1.5 h-1.5 rounded-full bg-amber-500"
    },
    preview: {
        widgetFrame: "bg-white rounded-[24px] shadow-xl border border-gray-200 overflow-hidden mx-auto max-w-[320px]",
        gradientHeader: "px-5 pt-6 pb-8 text-white",
        body: "p-4 flex flex-col gap-3 bg-gray-50 min-h-[200px]"
    }
};
